import type { IResource } from '@experiences/interfaces';

import { get } from '../utility/Requests';

export const externalApiResourceUrl = `/api/identity/ExternalApiResource`;

export function getExternalApiResources() {
    return get<IResource[]>(externalApiResourceUrl);
}
